import { z } from 'zod';
import type { Form } from './content.ts';
import { formInputs } from './form-content.ts';

export const siteAssistantQuickActionSchema = z.discriminatedUnion('kind', [
  z.strictObject({
    kind: z.literal('Prompt'),
    message: z.string().trim().min(1).max(100),
  }),
  z.strictObject({
    kind: z.literal('Link'),
    label: z.string().trim().min(1).max(80),
    url: z.url(),
  }),
]);
export const siteAssistantQuickActionsSchema = z.array(siteAssistantQuickActionSchema).max(3);
export type SiteAssistantQuickAction = z.infer<typeof siteAssistantQuickActionSchema>;

const supportedFieldTypes = new Set(['Text', 'TextArea', 'Email', 'Tel', 'Date', 'Select', 'RadioGroup']);

export function siteAssistantFormIssue(form: Form): string | undefined {
  if (form.archived) return 'Select a form from this site.';
  const required = formInputs(form).filter((field) => field.required);
  if (!required.length) return 'The Site Assistant form needs at least one required field.';
  const unsupported = required.find((field) => !supportedFieldTypes.has(field.type));
  if (unsupported)
    return `The required field "${unsupported.name}" uses ${unsupported.type}, which Site Assistant does not support. Use text, email, phone, date, or single-choice fields.`;
  const emptyChoice = required.find((field) => 'options' in field && !field.options.length);
  if (emptyChoice) return `Add at least one option to the required field "${emptyChoice.name}".`;
  if (!form.localizations.en) return 'Add English visitor text to the selected form.';
}
